/**
 * Turning a failed request into something a person can read. The message always comes from the
 * error code through i18n (CLAUDE.md hard rule 9) — never from whatever text the server produced.
 */

import i18n from "@/i18n";
import { ApiError } from "@/lib/api";

export function describeError(error: unknown): string {
  if (error instanceof ApiError) return error.localizedMessage;
  return i18n.t("errors.INTERNAL_ERROR");
}
